module.exports = __webpack_public_path__ + "static/media/Phone.2ca7ce0f.png";